import { FC, useState } from 'react';

import SvgIcon from '~src/shared/SvgIcon';

import { RemoveIcon } from './keyResults/createKeyResultListElement.sc';
import { removeAnimationTime } from './keyResults/CreateKeyResultListElement';
import { RemovableItemWrapper } from './removableItem.sc';

interface Props {
  remove(): void;
}

const RemovableItem: FC<Props> = (props) => {
  const [removing, setRemoving] = useState<boolean>(false);
  const removeThis = () => {
    setRemoving(true);
    setTimeout(() => {
      props.remove();
    }, removeAnimationTime);
  };

  return (
    <RemovableItemWrapper $remove={removing}>
      {props.children}
      <RemoveIcon onClick={removeThis}>
        <SvgIcon name="iconCross" />
      </RemoveIcon>
    </RemovableItemWrapper>
  );
};

export default RemovableItem;
